import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * AIModeSwitch Component
 * Simple AI Mode label with sliding toggle switch
 */
const AIModeSwitch = ({ style = {} }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/chat');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Open AI Chat"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        ...style
      }}
    >
      {/* AI MODE Label */}
      <span style={{
        color: '#D72638',
        fontSize: '14px',
        fontWeight: '700',
        letterSpacing: '0.05em',
        textTransform: 'uppercase'
      }}>
        AI MODE
      </span>

      {/* Toggle Switch */}
      <div style={{
        width: '50px',
        height: '28px',
        background: '#374151',
        borderRadius: '14px',
        position: 'relative',
        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)'
      }}>
        {/* Sliding Thumb - OFF position (left) */}
        <div style={{
          position: 'absolute',
          top: '3px',
          left: '3px',
          width: '22px',
          height: '22px',
          background: '#fff',
          borderRadius: '50%',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          transition: 'left 0.2s ease'
        }} />
      </div>
    </button>
  );
};

export default AIModeSwitch;
